export default function useInputRange({ props, start, end, emit }) {
  // 监听输入
  const change = (val, type) => {
    if (val == null || val == '') {
      props.value = []
      emit('input', [])
      return
    }
    if (!props.value) props.value = []
    if (type === 'start') {
      start.value = +`${val}`
      props.value[0] = start.value
    }
    if (type === 'end') {
      end.value = +`${val}`
      props.value[1] = end.value
    }

    emit('input', [start.value, end.value])
  }

  return { change }
}
